import { render } from "./Popup.vue?vue&type=template&id=868381ca&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=868381ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-868381ca"

export default script